/**
 * © 2026 iTech India Private Limited. All rights reserved.
 * Licensed under the iTech End User License Agreement (EULA).
 * Unauthorized use or distribution is prohibited.
 */

/**
 * Tamil strings — initial machine-assisted draft, pending translation-vendor
 * review (tracked as dependency E8). Missing keys fall back to English.
 */
const CLIENT = 'வாடிக்கையாளர்';
const SESSIONS = 'அமர்வுகள்';
const THERAPIST = 'சிகிச்சையாளர்';
const STATUS = 'நிலை';
const FULL_NAME = 'முழு பெயர்';
const PLAN = 'திட்டம்';
const MRR = 'MRR';
const TRIAL = 'சோதனை';
const SUBSCRIPTION = 'சந்தா';
const ACTION = 'செயல்';
const NO_SESSIONS = 'அமர்வுகள் இல்லை.';
const THERAPY_PLANS = 'சிகிச்சை திட்டங்கள்';
const REPORTS = 'அறிக்கைகள்';
const FILTER_BY_STATUS = 'நிலை வடிகட்டி';
const ALL_STATUS = 'அனைத்து நிலைகளும்';

export default {
  common: {
    appName: 'TherapyOS',
    loading: 'ஏற்றுகிறது…',
    save: 'மாற்றங்களைச் சேமி',
    cancel: 'ரத்துசெய்',
    signOut: 'வெளியேறு',
    search: 'தேடு…',
    loadError: 'தரவை ஏற்ற முடியவில்லை. மீண்டும் முயற்சிக்கவும்.',
    saveError: 'சேமிக்க முடியவில்லை. படிவத்தைச் சரிபார்த்து மீண்டும் முயற்சிக்கவும்.',
  },
  topbar: {
    back: 'பின் செல்',
    welcome: 'மீண்டும் வரவேற்கிறோம்',
    welcomeName: 'மீண்டும் வரவேற்கிறோம், {{name}}',
    addNew: 'புதிதாக சேர்',
    notifications: 'அறிவிப்புகள்',
    noNotifications: 'புதிய அறிவிப்புகள் இல்லை',
    toggleTheme: 'இருண்ட பயன்முறையை மாற்று',
  },
  status: {
    active: 'செயலில்',
    inactive: 'செயலற்றது',
    discharged: 'விடுவிக்கப்பட்டது',
    scheduled: 'திட்டமிடப்பட்டது',
    in_progress: 'நடப்பில்',
    completed: 'முடிந்தது',
    cancelled: 'ரத்து',
    no_show: 'வரவில்லை',
  },
  goalStatus: {
    not_started: 'தொடங்கவில்லை',
    emerging: 'உருவாகிறது',
    in_progress: 'நடப்பில்',
    achieved: 'அடைந்தது',
    maintenance: 'பராமரிப்பு',
    discontinued: 'நிறுத்தப்பட்டது',
  },
  measurementType: {
    frequency: 'அதிர்வெண்',
    percent_accuracy: 'சதவீத துல்லியம்',
    duration: 'கால அளவு',
    latency: 'தாமதம்',
    trials_to_criterion: 'அளவுகோலுக்கான முயற்சிகள்',
    rating_scale: 'மதிப்பீட்டு அளவுகோல்',
    independence_level: 'சுயாதீன நிலை',
    prompt_level: 'தூண்டல் நிலை',
    anecdotal: 'விவரணை',
  },
  sessionType: {
    individual: 'தனிநபர்',
    group: 'குழு',
    teletherapy: 'தொலைசிகிச்சை',
    assessment: 'மதிப்பீடு',
    review: 'மதிப்பாய்வு',
    supervision: 'மேற்பார்வை',
    home_visit: 'வீட்டு வருகை',
  },
  therapist: {
    dashboard: {
      myClients: 'எனது வாடிக்கையாளர்கள்',
      upcoming: 'வரவிருக்கும் அமர்வுகள்',
      plans: THERAPY_PLANS,
    },
    clients: {
      title: 'எனது வாடிக்கையாளர்கள்',
      count: '{{count}} வாடிக்கையாளர்கள்',
      searchPlaceholder: 'வாடிக்கையாளர்களைத் தேடு…',
      empty: 'வாடிக்கையாளர்கள் ஒதுக்கப்படவில்லை.',
    },
    notes: {
      title: 'அமர்வு குறிப்புகள்',
      subtitle: 'உங்கள் அமர்வுகளை ஆவணப்படுத்துங்கள்',
      count: 'ஆவணப்படுத்த {{count}} அமர்வுகள்',
      empty: 'ஆவணப்படுத்த அமர்வுகள் இல்லை.',
      open: 'குறிப்பைத் திற',
    },
    schedule: {
      title: 'அட்டவணை',
      subtitle: 'வாராந்திர அமர்வு நாட்காட்டி',
      add: 'புதிய அமர்வு',
      empty: 'வரவிருக்கும் அமர்வுகள் இல்லை.',
      noneDay: 'அமர்வுகள் இல்லை',
      prevWeek: 'முந்தைய வாரம்',
      nextWeek: 'அடுத்த வாரம்',
      thisWeek: 'இந்த வாரம்',
    },
    availability: {
      title: 'கிடைக்கும் நேரம்',
      subtitle: 'உங்கள் வாராந்திர வேலை நேரம்',
      save: 'சேமி',
      saved: 'கிடைக்கும் நேரம் சேமிக்கப்பட்டது.',
      saveError: 'சேமிக்க முடியவில்லை. மீண்டும் முயற்சிக்கவும்.',
      invalid:
        'நேர சாளரங்களைச் சரிபார்க்கவும் — முடிவு தொடக்கத்திற்குப் பின் இருக்க வேண்டும், சாளரங்கள் ஒன்றுடன் ஒன்று முரண்படக்கூடாது.',
      addWindow: 'சாளரம் சேர்',
      removeWindow: 'சாளரத்தை அகற்று',
      none: 'கிடைக்கவில்லை',
      days: {
        mon: 'திங்கள்',
        tue: 'செவ்வாய்',
        wed: 'புதன்',
        thu: 'வியாழன்',
        fri: 'வெள்ளி',
        sat: 'சனி',
        sun: 'ஞாயிறு',
      },
    },
    sessions: {
      title: SESSIONS,
      subtitle: 'இன்றைய அமர்வுகள்',
      empty: NO_SESSIONS,
      colClient: CLIENT,
      colType: 'வகை',
      colTime: 'நேரம்',
      colStatus: 'நிலை',
      colActions: 'செயல்கள்',
      start: 'தொடங்கு',
      complete: 'முடி',
      cancel: 'ரத்து',
      reschedule: 'மறுதிட்டமிடு',
      note: 'அமர்வு குறிப்பு',
      rate: 'மதிப்பிடு',
      rescheduleTitle: 'அமர்வை மறுதிட்டமிடு',
      rescheduleSubtitle:
        'புதிய நேரத்தைத் தேர்வுசெய்க. சிகிச்சையாளரின் மற்ற அமர்வுகளுடன் முரண்படும் நேரம் நிராகரிக்கப்படும்.',
    },
    rate: {
      title: 'அமர்வை மதிப்பிடு',
      subtitle: 'ஈடுபாடு, ஒத்துழைப்பு மற்றும் சூழல்',
      engagement: 'ஈடுபாடு',
      cooperation: 'ஒத்துழைப்பு',
      note: 'சூழல் குறிப்பு',
      unrated: 'மதிப்பிடப்படவில்லை',
      submit: 'மதிப்பீட்டைச் சேமி',
    },
    note: {
      title: 'அமர்வு குறிப்பு',
      back: 'அமர்வுகளுக்கு திரும்பு',
      signed: 'கையொப்பமிடப்பட்டது',
      trials: 'இலக்கு சோதனை தரவு',
      correct: 'சரி',
      incorrect: 'தவறு',
      prompted: 'தூண்டப்பட்டது',
      subjective: 'அகநிலை',
      objective: 'புறநிலை',
      assessment: 'மதிப்பீடு',
      plan: 'திட்டம்',
      saveDraft: 'வரைவைச் சேமி',
      sign: 'கையொப்பமிட்டு பூட்டு',
    },
    plans: {
      title: THERAPY_PLANS,
      subtitle: 'தனிப்பயன் சிகிச்சை திட்டங்கள்',
      count: '{{count}} செயல் திட்டங்கள்',
      searchPlaceholder: 'பெயரால் திட்டங்களைத் தேடு…',
      empty: 'திட்டங்கள் இல்லை.',
      progress: 'மொத்த முன்னேற்றம்',
      review: 'மறுஆய்வு',
      reviewDate: 'மறுஆய்வு தேதி',
      currentGoals: 'தற்போதைய இலக்குகள்',
      moreGoals: '+{{count}} மேலும்',
      viewDetails: 'விவரங்களைக் காண்க',
      updateProgress: 'முன்னேற்றத்தைப் புதுப்பி',
      detailsTitle: 'சிகிச்சை திட்ட விவரங்கள்',
      client: CLIENT,
      program: 'திட்டம்',
      startDate: 'தொடக்க தேதி',
      goals: 'இலக்குகள்',
    },
    planForm: {
      newPlan: 'புதிய திட்டம்',
      subtitle: 'வாடிக்கையாளருக்கான சிகிச்சை திட்டத்தையும் இலக்குகளையும் உருவாக்குங்கள்.',
      fromTemplate: 'டெம்ப்ளேட்டிலிருந்து தொடங்கு',
      fromTemplateNone: 'டெம்ப்ளேட் இல்லை — காலியாகத் தொடங்கு',
      client: CLIENT,
      selectClient: 'வாடிக்கையாளரைத் தேர்ந்தெடுக்கவும்',
      name: 'திட்டப் பெயர்',
      programType: 'திட்ட வகை',
      startDate: 'தொடக்க தேதி',
      reviewDate: 'மறுஆய்வு தேதி',
      goals: 'இலக்குகள்',
      addGoal: 'இலக்கைச் சேர்',
      goalN: 'இலக்கு {{n}}',
      goalTitle: 'இலக்கு',
      domain: 'துறை',
      selectDomain: 'துறையைத் தேர்ந்தெடு',
      measurementType: 'அளவீட்டு முறை',
      selectMeasurementType: 'முறையைத் தேர்ந்தெடு',
      measure: 'அளவீட்டு விவரம்',
      baseline: 'அடிப்படை',
      target: 'இலக்கு மதிப்பு',
      goalReviewDate: 'இலக்கு மறுஆய்வு தேதி',
      approachTags: 'அணுகுமுறை குறிச்சொற்கள்',
      approachTagsHint: 'காற்புள்ளியால் பிரிக்கவும், எ.கா. PECS, DTT',
      subTargets: 'துணை இலக்குகள்',
      subTargetsHint:
        '; ஆல் பிரிக்கவும் — > பின் படிகளைச் சேர்க்கவும், எ.கா. பின்பற்று > மாதிரி, தூண்டல்',
      fromLibrary: 'நூலகத்திலிருந்து',
      allDomains: 'அனைத்து துறைகள்',
      pickDomain: 'துறை வடிகட்டி',
      pickGoal: 'இலக்கைத் தேர்வுசெய்க…',
      domains: {
        SLT: 'பேச்சு & மொழி',
        OT: 'தொழில்சார் சிகிச்சை',
        ABA: 'நடத்தை பகுப்பாய்வு',
        PT: 'உடல் சிகிச்சை',
        SPECED: 'சிறப்புக் கல்வி',
      },
      removeGoal: 'இலக்கை அகற்று',
      submit: 'திட்டத்தை உருவாக்கு',
    },
    plan: {
      back: 'திட்டங்களுக்கு திரும்பு',
      goals: 'தற்போதைய இலக்குகள்',
      noGoals: 'இலக்குகள் இல்லை.',
      updateStatus: 'இலக்கு நிலையை புதுப்பி',
      subTargets: 'துணை இலக்குகள்',
      reviewBy: '{{date}} க்குள் மறுஆய்வு',
      statusNote: 'நிலை-மாற்ற குறிப்பு (விருப்பம்)',
      statusNotePlaceholder: 'நிலை ஏன் மாறுகிறது?',
      history: 'நிலை வரலாறு',
      showHistory: 'நிலை வரலாறு',
      hideHistory: 'வரலாற்றை மறை',
      noHistory: 'இதுவரை நிலை மாற்றம் பதிவாகவில்லை.',
      historyEntry: '{{from}} → {{to}}',
      historyInitial: '{{to}} ஆக அமைக்கப்பட்டது',
      saveAsTemplate: 'டெம்ப்ளேட்டாகச் சேமி',
      exportPdf: 'PDF ஏற்றுமதி',
      exporting: 'ஏற்றுமதி செய்கிறது…',
      saveTemplateTitle: 'டெம்ப்ளேட்டாகச் சேமி',
      saveTemplateSubtitle: 'எதிர்கால திட்டங்களில் இந்த இலக்குகளை மீண்டும் பயன்படுத்துங்கள்.',
      templateName: 'டெம்ப்ளேட் பெயர்',
    },
    templates: {
      title: 'டெம்ப்ளேட்டுகள்',
      subtitle: 'உங்கள் கிளினிக்கிற்கான மீண்டும் பயன்படுத்தக்கூடிய இலக்குத் தொகுப்புகள்',
      empty: 'டெம்ப்ளேட்டுகள் இல்லை. ஒரு திட்டத்தை டெம்ப்ளேட்டாகச் சேமியுங்கள்.',
      goalCount: '{{count}} இலக்குகள்',
      delete: 'டெம்ப்ளேட்டை நீக்கு',
    },
    collaborators: {
      title: 'ஒத்துழைக்கும் சிகிச்சையாளர்கள்',
      none: 'ஒத்துழைப்பாளர்கள் இல்லை.',
      add: 'ஒத்துழைப்பாளரைச் சேர்…',
      remove: 'ஒத்துழைப்பாளரை அகற்று',
    },
    review: {
      title: 'மருத்துவ மதிப்பாய்வுகள்',
      due: 'மதிப்பாய்வு நிலுவையில்',
      dueBanner: '{{count}} திட்டங்கள் மருத்துவ மதிப்பாய்வுக்கு நிலுவையில் உள்ளன',
      record: 'மதிப்பாய்வைப் பதிவு செய்',
      empty: 'இதுவரை மதிப்பாய்வுகள் பதிவு செய்யப்படவில்லை.',
      modalTitle: 'மருத்துவ மதிப்பாய்வைப் பதிவு செய்',
      modalSubtitle: 'மதிப்பாய்வு முடிவைப் பதிவு செய்து அடுத்த மதிப்பாய்வு தேதியை அமைக்கவும்.',
      outcome: 'முடிவு',
      outcome_continue: 'திட்டத்தைத் தொடரவும்',
      outcome_revise: 'திட்டத்தைத் திருத்தவும்',
      outcome_discharge: 'வெளியேற்றம்',
      summary: 'சுருக்கம்',
      recommendations: 'பரிந்துரைகள் (விருப்பம்)',
      nextDate: 'அடுத்த மதிப்பாய்வு தேதி',
      submit: 'மதிப்பாய்வைச் சேமி',
    },
    homeTasks: {
      link: 'வீட்டுப் பணிகள்',
      back: 'எனது வாடிக்கையாளர்களுக்குத் திரும்பு',
      title: 'வீட்டுப் பணிகள்',
      subtitle: 'வீட்டு-திட்டப் பணிகளை ஒதுக்கி மதிப்பாய்வு செய்',
    },
  },
  parent: {
    selectChild: 'குழந்தை',
    noData: 'இன்னும் தரவு பதிவு செய்யப்படவில்லை',
    dashboard: {
      title: 'வரவேற்கிறோம்',
      subtitle: 'உங்கள் குழந்தைகளின் சிகிச்சை சுருக்கம்',
      empty: 'குழந்தைகள் எவரும் சேர்க்கப்படவில்லை.',
      progress: 'மொத்த முன்னேற்றம்',
      viewProgress: 'முன்னேற்றத்தைக் காண்க →',
      recentReports: 'சமீபத்திய அறிக்கைகள்',
    },
    achievements: {
      dayStreak: '{{count}} நாள் தொடர்',
      completed: '{{count}} முடிந்தது',
      badge: {
        firstStep: 'முதல் படி',
        threeDay: '3-நாள் தொடர்',
        weekWarrior: 'வார வீரர்',
        fiftyDone: '50 முடிந்தது',
      },
    },
    progress: {
      title: 'முன்னேற்றம்',
      subtitle: 'காலப்போக்கில் இலக்கு துல்லியம்',
      empty: 'இன்னும் முன்னேற்றத் தரவு பதிவு செய்யப்படவில்லை.',
    },
    sessions: {
      title: SESSIONS,
      subtitle: 'உங்கள் குழந்தைகளின் சிகிச்சை அட்டவணை',
      empty: NO_SESSIONS,
      colChild: 'குழந்தை',
      colType: 'வகை',
      colTime: 'நேரம்',
      colStatus: 'நிலை',
    },
    billing: {
      title: 'பில்லிங்',
      subtitle: 'உங்கள் விலைப்பட்டியல்கள் மற்றும் கட்டணங்கள்',
      empty: 'விலைப்பட்டியல்கள் இல்லை.',
      payNow: 'இப்போது செலுத்து',
      payNowTitle: 'விலைப்பட்டியலைச் செலுத்து',
      payNowSubtitle: 'நிலுவைத் தொகையைப் பாதுகாப்பாகச் செலுத்துங்கள் (Razorpay).',
      payConfirm: 'இப்போது செலுத்து',
      paying: 'செயலாக்கப்படுகிறது…',
      payError: 'கட்டணத்தைச் செயலாக்க முடியவில்லை. மீண்டும் முயற்சிக்கவும்.',
    },
    reports: {
      title: REPORTS,
      count: '{{count}} அறிக்கைகள்',
      empty: 'உங்களுடன் பகிரப்பட்ட அறிக்கைகள் இல்லை.',
    },
    homeTasks: {
      title: 'வீட்டுப் பணிகள்',
      subtitle: 'இன்றைய வீட்டு சிகிச்சை பயிற்சி',
      dailyProgress: 'தினசரி முன்னேற்றம்',
      completedCount: '{{done}} / {{total}} இன்று முடிந்தது',
      completed: 'முடிந்தது ✓',
      dueToday: 'இன்று செய்ய வேண்டும்',
      markDone: 'முடிந்ததாகக் குறி',
      empty: 'வீட்டுப் பணிகள் ஒதுக்கப்படவில்லை.',
    },
  },
  admin: {
    dashboard: {
      activeClients: 'செயலில் உள்ள வாடிக்கையாளர்கள்',
      therapists: 'சிகிச்சையாளர்கள்',
      sessions: SESSIONS,
      sessionsThisMonth: 'இந்த மாத அமர்வுகள்',
      avgProgress: 'சராசரி திட்ட முன்னேற்றம்',
      plans: THERAPY_PLANS,
      distribution: 'வாடிக்கையாளர் பகிர்வு',
      distributionSub: 'சிகிச்சை வகை வாரியாக',
      sessionsTrend: 'அமர்வுகள்',
      sessionsTrendSub: 'கடந்த 6 மாதங்கள்',
      performance: 'சிகிச்சையாளர் செயல்திறன்',
      performanceSub: 'சிறந்தவர்கள்',
      sessionsUnit: '{{count}} அமர்வுகள்',
      upcoming: 'வரவிருக்கும் அமர்வுகள்',
      upcomingSub: 'இன்றைய அட்டவணை',
      noUpcoming: 'வரவிருக்கும் அமர்வுகள் இல்லை.',
      noData: 'தரவு இல்லை.',
      viewAll: 'அனைத்தையும் காண்க',
      activity: 'சமீபத்திய செயல்பாடு',
      activitySub: 'சமீபத்தில் முடிந்த அமர்வுகள்',
      noActivity: 'சமீபத்திய செயல்பாடு இல்லை.',
      activitySession: '{{client}} ஒரு அமர்வை முடித்தார்',
    },
    clients: {
      title: 'வாடிக்கையாளர் மேலாண்மை',
      subtitle: 'உங்கள் கிளினிக்கில் சேர்க்கப்பட்ட குழந்தைகள்',
      count: 'மொத்தம் {{count}} வாடிக்கையாளர்கள்',
      add: 'வாடிக்கையாளரைச் சேர்',
      edit: 'வாடிக்கையாளரைத் திருத்து',
      addSubtitle: 'புதிய வாடிக்கையாளர் பதிவை உருவாக்கவும்',
      empty: 'இன்னும் வாடிக்கையாளர்கள் இல்லை.',
      searchPlaceholder: 'வாடிக்கையாளர், நோயறிதல், சிகிச்சையாளரைத் தேடு…',
      statusFilter: FILTER_BY_STATUS,
      allStatus: ALL_STATUS,
      age: 'வயது {{age}}',
      colName: CLIENT,
      colDiagnosis: 'நோயறிதல்',
      colTherapist: THERAPIST,
      colSessions: SESSIONS,
      colProgress: 'முன்னேற்றம்',
      colStatus: 'நிலை',
      colActions: 'செயல்கள்',
      deleteTitle: 'வாடிக்கையாளரை நீக்கவா?',
      deleteBody:
        '{{name}} மற்றும் அவர்களின் அனைத்து பதிவுகளையும் நிரந்தரமாக நீக்கும். இதை மீட்க முடியாது.',
    },
    clientDetail: {
      back: 'வாடிக்கையாளர்களுக்குத் திரும்பு',
      notFound: 'வாடிக்கையாளர் கிடைக்கவில்லை.',
      age: 'வயது',
      therapist: THERAPIST,
      guardian: 'பாதுகாவலர்',
      contact: 'தொடர்பு',
      plans: THERAPY_PLANS,
      noPlans: 'திட்டங்கள் இல்லை.',
      sessions: 'சமீபத்திய அமர்வுகள்',
      noSessions: NO_SESSIONS,
      billing: 'பில்லிங்',
      noInvoices: 'விலைப்பட்டியல்கள் இல்லை.',
    },
    sessions: {
      title: SESSIONS,
      count: '{{count}} அமர்வுகள்',
      empty: NO_SESSIONS,
      searchPlaceholder: 'வகை அல்லது இடத்தால் தேடு…',
      statusFilter: FILTER_BY_STATUS,
      allStatus: ALL_STATUS,
      schedule: 'அமர்வைத் திட்டமிடு',
      scheduleSubtitle: 'புதிய சிகிச்சை அமர்வைப் பதிவு செய்',
      colClient: CLIENT,
      colTherapist: THERAPIST,
      colType: 'வகை',
      colTime: 'நேரம்',
      colStatus: 'நிலை',
    },
    users: {
      title: 'குழு உறுப்பினர்கள்',
      count: 'மொத்தம் {{count}} பயனர்கள்',
      invite: 'பயனரை அழைக்கவும்',
      inviteTitle: 'குழு உறுப்பினரை அழைக்கவும்',
      inviteSubtitle: 'கடவுச்சொல்லை அமைக்க அவர்களுக்கு மின்னஞ்சல் அனுப்பப்படும்.',
      empty: 'இன்னும் குழு உறுப்பினர்கள் இல்லை. தொடங்க உங்கள் முதல் பயனரை அழைக்கவும்.',
      enable: 'இயக்கு',
      disable: 'முடக்கு',
      name: FULL_NAME,
      email: 'மின்னஞ்சல்',
      role: 'பங்கு',
      inviteError: 'அழைப்பை அனுப்ப முடியவில்லை. மீண்டும் முயற்சிக்கவும்.',
      col: {
        name: 'பெயர்',
        email: 'மின்னஞ்சல் முகவரி',
        roles: 'பங்குகள்',
        status: 'நிலை',
        lastLogin: 'கடைசி உள்நுழைவு',
      },
      role_CLINIC_ADMIN: 'கிளினிக் நிர்வாகி',
      role_THERAPIST: 'சிகிச்சையாளர்',
      role_FINANCE: 'நிதி',
      status_invited: 'அழைக்கப்பட்டது',
      status_active: 'செயலில்',
      status_disabled: 'முடக்கப்பட்டது',
    },
    therapists: {
      title: 'சிகிச்சையாளர் மேலாண்மை',
      subtitle: 'உங்கள் கிளினிக்கின் மருத்துவ ஊழியர்கள்',
      registered: '{{count}} சிகிச்சையாளர்கள் பதிவு செய்யப்பட்டுள்ளனர்',
      add: 'சிகிச்சையாளரைச் சேர்',
      addSubtitle: 'புதிய சிகிச்சையாளர் சுயவிவரத்தை உருவாக்கவும்',
      empty: 'இன்னும் சிகிச்சையாளர்கள் இல்லை.',
      searchPlaceholder: 'சிகிச்சையாளர்களைத் தேடு…',
      statusFilter: FILTER_BY_STATUS,
      allStatus: ALL_STATUS,
      clients: 'வாடிக்கையாளர்கள்',
      sessions: SESSIONS,
      rating: 'மதிப்பீடு',
      joined: 'சேர்ந்தது {{date}}',
    },
    finance: {
      title: 'நிதி',
      count: '{{count}} விலைப்பட்டியல்கள்',
    },
    reports: {
      title: REPORTS,
      count: '{{count}} அறிக்கைகள்',
    },
    invite: {
      title: 'பெற்றோரை அழைக்கவும்',
      subtitle: 'இந்தக் குழந்தைக்கு பெற்றோர் உள்நுழைவை உருவாக்கவும்',
      intro: '{{child}} இன் பெற்றோருக்கு பெற்றோர் போர்டலை அணுக அழைப்பு அனுப்பவும்.',
      parentName: 'பெற்றோரின் முழு பெயர்',
      email: 'பெற்றோரின் மின்னஞ்சல்',
      submit: 'அழைப்பு அனுப்பு',
      error: 'அழைப்பை அனுப்ப முடியவில்லை. மின்னஞ்சல் ஏற்கனவே பயன்பாட்டில் இருக்கலாம்.',
      success: '{{email}} க்கு அழைப்பு மின்னஞ்சல் அனுப்பப்பட்டது.',
      linkLabel: 'செயல்படுத்தும் இணைப்பு',
      copy: 'நகலெடு',
      copied: 'நகலெடுக்கப்பட்டது',
      note: 'இந்த இணைப்பைப் பெற்றோருக்கு மின்னஞ்சல் அனுப்பியுள்ளோம். நீங்களும் நகலெடுத்துப் பகிரலாம் — கடவுச்சொல் அமைத்து உள்நுழைய உதவும், 7 நாட்களில் காலாவதியாகும்.',
    },
  },
  form: {
    client: {
      fullName: FULL_NAME,
      age: 'வயது',
      primaryDiagnosis: 'நோயறிதல்',
      email: 'மின்னஞ்சல்',
      phone: 'தொலைபேசி',
      assignTherapist: 'ஒதுக்கப்பட்ட சிகிச்சையாளர்',
      noTherapist: 'சிகிச்சையாளர் ஒதுக்கப்படவில்லை',
      submit: 'வாடிக்கையாளரைச் சேர்',
      guardianName: 'பெற்றோர் / பாதுகாவலர் பெயர்',
      inviteParentNow: 'பெற்றோர் உள்நுழைவையும் உருவாக்கவும்',
      inviteParentHint: 'பெற்றோர் போர்ட்டலை அணுக செயல்படுத்தும் இணைப்பை மின்னஞ்சல் அனுப்புவோம்.',
      parentName: 'பெற்றோரின் முழு பெயர்',
      parentEmail: 'பெற்றோரின் மின்னஞ்சல்',
    },
    therapist: {
      fullName: FULL_NAME,
      email: 'மின்னஞ்சல் முகவரி',
      phone: 'தொலைபேசி',
      specialty: 'நிபுணத்துவம்',
      specialisations: 'நிபுணத்துவங்கள்',
      specialisationsHint: 'கமாவால் பிரிக்கவும், எ.கா. ASD, பேச்சு, OT',
      joinedOn: 'சேர்ந்த தேதி',
      submit: 'சிகிச்சையாளரைச் சேர்',
    },
    session: {
      client: CLIENT,
      selectClient: 'வாடிக்கையாளரைத் தேர்ந்தெடு',
      therapist: THERAPIST,
      anyTherapist: 'எந்த சிகிச்சையாளரும்',
      type: 'அமர்வு வகை',
      typeHint: 'எ.கா. பேச்சு சிகிச்சை',
      anyType: 'எந்த வகையும்',
      start: 'தேதி & நேரம்',
      submit: 'அமர்வைத் திட்டமிடு',
    },
    reschedule: {
      start: 'புதிய தேதி & நேரம்',
      submit: 'மறுதிட்டமிடு',
      conflict: 'அந்த நேரம் இந்த சிகிச்சையாளரின் மற்றொரு அமர்வுடன் முரண்படுகிறது.',
    },
    invoice: {
      client: CLIENT,
      selectClient: 'வாடிக்கையாளரைத் தேர்ந்தெடு',
      service: 'சேவை',
      serviceCustom: 'தனிப்பயன் தொகை',
      amount: 'தொகை (₹)',
      amountHint: 'எ.கா. 2500',
      dueDate: 'செலுத்த வேண்டிய தேதி',
      notes: 'குறிப்புகள்',
      notesHint: 'எ.கா. ஜூன் பேச்சு சிகிச்சை அமர்வுகள்',
      submit: 'விலைப்பட்டியல் உருவாக்கு',
    },
    payment: {
      balance: 'நிலுவைத் தொகை: {{amount}}',
      amount: 'தொகை (₹)',
      method: 'கட்டண முறை',
      selectMethod: 'முறையைத் தேர்ந்தெடு',
      submit: 'கட்டணம் பதிவு செய்',
    },
    homeTask: {
      title: 'பணி',
      titleHint: 'எ.கா. விளையாட்டின் போது கண் தொடர்பை பயிற்சி செய் (10 நிமி)',
      category: 'வகை',
      selectCategory: 'வகையைத் தேர்ந்தெடு',
      instructions: 'வழிமுறைகள்',
      instructionsHint: 'பெற்றோருக்கான விருப்ப வழிகாட்டுதல்',
      submit: 'பணியை ஒதுக்கு',
    },
  },
  login: {
    welcome: 'மீண்டும் வரவேற்கிறோம்',
    subtitle: 'உங்கள் போர்ட்டலில் உள்நுழையவும்',
    selectRole: 'உங்கள் பங்கை தேர்ந்தெடுக்கவும்',
    email: 'மின்னஞ்சல் முகவரி',
    emailPlaceholder: 'உங்கள் மின்னஞ்சலை உள்ளிடவும்',
    password: 'கடவுச்சொல்',
    passwordPlaceholder: 'உங்கள் கடவுச்சொல்லை உள்ளிடவும்',
    forgotPassword: 'கடவுச்சொல் மறந்துவிட்டதா?',
    roles: {
      PARENT: {
        title: 'பெற்றோர் போர்டல்',
        blurb: 'உங்கள் குழந்தையின் முன்னேற்றத்தை கண்காணிக்கவும்',
      },
    },
  },
  forgot: {
    title: 'கடவுச்சொல்லை மீட்டமைக்கவும்',
    subtitle: 'உங்கள் மின்னஞ்சலை உள்ளிடவும், மீட்டமைப்பு இணைப்பை அனுப்புவோம்.',
    submit: 'மீட்டமைப்பு இணைப்பை அனுப்பு',
    sentTitle: 'உங்கள் மின்னஞ்சலைப் பார்க்கவும்',
    sentBody:
      'அந்த மின்னஞ்சலுக்கு கணக்கு இருந்தால், கடவுச்சொல்லை மீட்டமைக்க இணைப்பை அனுப்பியுள்ளோம். இணைப்பு 1 மணி நேரத்தில் காலாவதியாகும்.',
    backToLogin: 'உள்நுழைவுக்குத் திரும்பு',
  },
  pagination: {
    prev: 'முந்தையது',
    next: 'அடுத்தது',
    pageOf: 'பக்கம் {{page}} / {{total}}',
  },
  account: {
    changePassword: {
      title: 'கடவுச்சொல்லை மாற்று',
      subtitle: 'உங்கள் கணக்கின் கடவுச்சொல்லைப் புதுப்பிக்கவும்.',
      current: 'தற்போதைய கடவுச்சொல்',
      new: 'புதிய கடவுச்சொல்',
      submit: 'கடவுச்சொல்லைப் புதுப்பி',
      success: 'உங்கள் கடவுச்சொல் புதுப்பிக்கப்பட்டது.',
      error:
        'கடவுச்சொல்லை மாற்ற முடியவில்லை. தற்போதைய கடவுச்சொல்லைச் சரிபார்த்து மீண்டும் முயற்சிக்கவும்.',
    },
  },
  setPassword: {
    title: 'உங்கள் கடவுச்சொல்லை அமைக்கவும்',
    subtitle: 'உங்கள் கணக்கைச் செயல்படுத்த ஒரு கடவுச்சொல்லைத் தேர்ந்தெடுக்கவும்.',
    newPassword: 'புதிய கடவுச்சொல்',
    confirmPassword: 'கடவுச்சொல்லை உறுதிப்படுத்தவும்',
    submit: 'கடவுச்சொல்லை அமைக்கவும்',
    missingToken: 'இந்த இணைப்பு செல்லாதது அல்லது அதன் டோக்கன் இல்லை.',
    error: 'இந்த இணைப்பு செல்லாதது அல்லது காலாவதியானது. மீண்டும் அனுப்பச் சொல்லுங்கள்.',
    doneTitle: 'கடவுச்சொல் அமைக்கப்பட்டது',
    doneBody: 'உங்கள் கணக்கு செயலில் உள்ளது. இப்போது உள்நுழையலாம்.',
    goToLogin: 'உள்நுழைவுக்குச் செல்லவும்',
  },
  nav: {
    dashboard: 'முகப்பு',
    inbox: 'இன்பாக்ஸ்',
    progress: 'முன்னேற்றம்',
    sessions: SESSIONS,
    availability: 'கிடைக்கும் நேரம்',
    homeTasks: 'வீட்டு பணிகள்',
    reports: REPORTS,
    billing: 'கட்டணம்',
    catalogue: 'பட்டியல்',
    messages: 'செய்திகள்',
    staffUsers: 'பணியாளர் பயனர்கள்',
    users: 'பயனர்கள்',
  },
  inbox: {
    title: 'இன்பாக்ஸ்',
    subtitle: 'உங்கள் அறிவிப்புகள் மற்றும் எச்சரிக்கைகள்',
    all: 'அனைத்தும்',
    unread: 'படிக்காதவை',
    markAllRead: 'அனைத்தையும் படித்ததாகக் குறி',
    empty: 'புதிய அறிவிப்புகள் இல்லை',
    viewAll: 'அனைத்து அறிவிப்புகளையும் காண்க',
  },
  finance: {
    dashboard: {
      invoiced: 'மொத்த விலைப்பட்டியல்',
      collected: 'வசூலிக்கப்பட்டது',
      outstanding: 'நிலுவை',
      invoices: 'விலைப்பட்டியல்கள்',
      revenueTrend: 'வருவாய்',
      revenueTrendSub: 'வசூலிக்கப்பட்டது, கடந்த 6 மாதங்கள்',
    },
    invoices: {
      title: 'விலைப்பட்டியல்கள்',
      count: '{{count}} விலைப்பட்டியல்கள்',
      add: 'புதிய விலைப்பட்டியல்',
      addSubtitle: 'வாடிக்கையாளருக்கு புதிய விலைப்பட்டியல் உருவாக்கு',
      empty: 'விலைப்பட்டியல்கள் இல்லை.',
      searchPlaceholder: 'விலைப்பட்டியல் எண் அல்லது குறிப்புகளால் தேடு…',
      statusFilter: FILTER_BY_STATUS,
      allStatus: ALL_STATUS,
      recordPayment: 'கட்டணம் பதிவு செய்',
      recordPaymentSubtitle: 'இந்த விலைப்பட்டியலுக்கு கட்டணம் பதிவு செய்',
      col: {
        number: 'விலைப்பட்டியல்',
        client: CLIENT,
        amount: 'தொகை',
        balance: 'இருப்பு',
        due: 'நிலுவை தேதி',
        status: 'நிலை',
      },
    },
    reports: {
      title: REPORTS,
      count: '{{count}} அறிக்கைகள்',
    },
    catalogue: {
      title: 'சேவை பட்டியல்',
      count: '{{count}} சேவைகள்',
      add: 'சேவை சேர்',
      addTitle: 'சேவை சேர்',
      editTitle: 'சேவையைத் திருத்து',
      subtitle: 'இயல்புநிலை விலையுடன் ஒரு சேவை; விலைப்பட்டியல்கள் இதிலிருந்து விலை பெறும்.',
      name: 'சேவை பெயர்',
      price: 'இயல்புநிலை விலை (₹)',
      priceHint: 'எ.கா. 2500',
      description: 'விளக்கம் (விருப்பம்)',
      save: 'சேவையைச் சேமி',
      empty: 'சேவைகள் இல்லை — முதல் கட்டண பட்டியலைச் சேர்.',
      edit: 'சேவையைத் திருத்து',
      delete: 'சேவையை அகற்று',
      inactive: 'செயலற்றது',
    },
  },
  reports: {
    recent: 'சமீபத்திய அறிக்கைகள்',
    generate: 'அறிக்கை உருவாக்கு',
    generateError: 'அந்த அறிக்கையைத் தொடங்க முடியவில்லை. மீண்டும் முயற்சிக்கவும்.',
    loading: 'அறிக்கைகள் ஏற்றப்படுகிறது…',
    error: 'அறிக்கைகளை ஏற்ற முடியவில்லை.',
    empty: 'இன்னும் அறிக்கைகள் இல்லை — மேலே ஒன்றை உருவாக்கவும்.',
    download: 'பதிவிறக்கு',
    field: {
      type: 'அறிக்கை வகை',
      client: CLIENT,
      selectClient: 'வாடிக்கையாளரைத் தேர்ந்தெடுக்கவும்',
      from: 'முதல்',
      to: 'வரை',
    },
    type: {
      client_progress: 'வாடிக்கையாளர் முன்னேற்றம்',
      attendance: 'வருகை',
      revenue: 'வருவாய்',
    },
    status: {
      queued: 'வரிசையில்',
      running: 'உருவாக்குகிறது…',
      succeeded: 'தயார்',
      failed: 'தோல்வி',
    },
    col: {
      report: 'அறிக்கை',
      status: 'நிலை',
      created: 'உருவாக்கப்பட்டது',
      action: '',
    },
  },
  invoiceStatus: {
    draft: 'வரைவு',
    sent: 'அனுப்பப்பட்டது',
    partial: 'பகுதி',
    paid: 'செலுத்தப்பட்டது',
    overdue: 'தாமதம்',
    void: 'ரத்து',
  },
  payroll: {
    title: 'ஊதியம்',
    count: '{{count}} இயக்கங்கள்',
    add: 'புதிய ஊதிய இயக்கம்',
    addSubtitle: 'ஒரு ஊதிய காலத்திற்கான இயக்கத்தை உருவாக்கு',
    empty: 'ஊதிய இயக்கங்கள் இல்லை.',
    colPeriod: 'காலம்',
    colTotal: 'மொத்தம்',
    colStatus: 'நிலை',
    form: {
      period: 'ஊதிய காலம்',
      periodHint: 'எ.கா. ஜூன் 2026',
      start: 'காலத் தொடக்கம்',
      end: 'கால முடிவு',
      notes: 'குறிப்புகள்',
      submit: 'இயக்கத்தை உருவாக்கு',
      therapist: THERAPIST,
      selectTherapist: 'சிகிச்சையாளரைத் தேர்ந்தெடு',
      gross: 'மொத்த ஊதியம் (₹)',
      sessions: SESSIONS,
      addSubmit: 'ஊதியச் சீட்டைச் சேர்',
    },
    detail: {
      title: 'ஊதிய இயக்கம்',
      total: 'மொத்தம்: {{amount}}',
      addPayslip: 'ஊதியச் சீட்டைச் சேர்',
      addSubtitle: 'இந்த இயக்கத்திற்கு சிகிச்சையாளர் ஊதியச் சீட்டைச் சேர்',
      process: 'செயலாக்கு',
      empty: 'ஊதியச் சீட்டுகள் இல்லை.',
      colTherapist: THERAPIST,
      colSessions: SESSIONS,
      colGross: 'மொத்தம்',
    },
  },
  payrollStatus: {
    draft: 'வரைவு',
    processed: 'செயலாக்கப்பட்டது',
    paid: 'செலுத்தப்பட்டது',
  },
  paymentMethod: {
    cash: 'பணம்',
    card: 'அட்டை',
    upi: 'UPI',
    bank_transfer: 'வங்கி பரிமாற்றம்',
    razorpay: 'Razorpay',
  },
  home: {
    assign: 'பணியை ஒதுக்கு',
    assignSubtitle: 'இந்த வாடிக்கையாளருக்கு வீட்டு-திட்டப் பணியைச் சேர்',
  },
  analytics: {
    title: 'பகுப்பாய்வு',
    subtitle: 'கிளினிக் செயல்திறன் ஒரு பார்வையில்',
    financeSubtitle: 'வருவாய் மற்றும் வசூல் ஒரு பார்வையில்',
    totalClients: 'மொத்த வாடிக்கையாளர்கள்',
    completedSessions: 'முடிந்த அமர்வுகள்',
    sessionsByStatus: 'நிலை வாரியாக அமர்வுகள்',
    clientsByStatus: 'நிலை வாரியாக வாடிக்கையாளர்கள்',
    invoicesByStatus: 'நிலை வாரியாக விலைப்பட்டியல்கள்',
    collections: 'விலைப்பட்டியல் vs வசூல் (₹)',
  },
  settings: {
    title: 'அமைப்புகள்',
    subtitle: 'உங்கள் கிளினிக் சுயவிவரத்தை நிர்வகி',
    name: 'கிளினிக் பெயர்',
    legalName: 'சட்டப்பூர்வ பெயர்',
    email: 'தொடர்பு மின்னஞ்சல்',
    phone: 'தொடர்பு தொலைபேசி',
    timezone: 'நேர மண்டலம்',
    gstin: 'GSTIN',
    address: 'முகவரி',
    line1: 'முகவரி வரி 1',
    line2: 'முகவரி வரி 2',
    city: 'நகரம்',
    state: 'மாநிலம்',
    postalCode: 'அஞ்சல் குறியீடு',
    country: 'நாடு (ISO)',
    save: 'மாற்றங்களைச் சேமி',
    saved: 'அமைப்புகள் சேமிக்கப்பட்டன.',
    tabs: { profile: 'சுயவிவரம்', notifications: 'அறிவிப்புகள்', security: 'பாதுகாப்பு' },
    notifications: {
      sessionReminders: 'அமர்வு நினைவூட்டல்கள்',
      sessionRemindersDesc: 'வரவிருக்கும் அமர்வுகளுக்கு முன் மின்னஞ்சல் நினைவூட்டல்கள்.',
      paymentAlerts: 'கட்டண எச்சரிக்கைகள்',
      paymentAlertsDesc:
        'விலைப்பட்டியல்கள் செலுத்தப்படும்போது அல்லது நிலுவையில் இருக்கும்போது அறிவிக்கவும்.',
      progressReports: 'முன்னேற்ற அறிக்கைகள்',
      progressReportsDesc: 'முன்னேற்ற அறிக்கை தயாராக இருக்கும்போது அறிவிக்கவும்.',
      systemUpdates: 'அமைப்பு புதுப்பிப்புகள்',
      systemUpdatesDesc: 'தளம் மற்றும் பராமரிப்பு அறிவிப்புகள்.',
    },
    security: {
      subtitle:
        'உங்கள் கணக்கின் கடவுச்சொல்லை மாற்றவும். இந்த சாதனத்தில் நீங்கள் உள்நுழைந்தே இருப்பீர்கள்.',
    },
  },
  messages: {
    title: 'செய்திகள்',
    new: 'புதிய செய்தி',
    newSubtitle: 'ஒரு தொடர்புடன் உரையாடலைத் தொடங்கு',
    empty: 'செய்திகள் இல்லை.',
    conversation: 'உரையாடல்',
    composer: 'செய்தியைத் தட்டச்சு செய்…',
    noContacts: 'செய்தி அனுப்ப தொடர்புகள் இல்லை.',
    selectContact: 'தொடர்பைத் தேர்ந்தெடு',
    startChat: 'அரட்டையைத் தொடங்கு',
    pickConversation: 'அரட்டையைத் தொடங்க உரையாடலைத் தேர்ந்தெடு',
  },
  homeCategory: {
    social: 'சமூகம்',
    sensory: 'உணர்வு',
    cognitive: 'அறிவாற்றல்',
    communication: 'தொடர்பு',
    motor: 'இயக்கம்',
    other: 'மற்றவை',
  },
  sa: {
    dashboard: {
      title: 'தளக் கண்ணோட்டம்',
      subtitle: 'TherapyOS-இல் உள்ள அனைத்து கிளினிக்குகளும்',
      empty: 'இன்னும் தரவு இல்லை.',
      totalClinics: 'மொத்த கிளினிக்குகள்',
      activeClinics: 'செயலில் உள்ள கிளினிக்குகள்',
      mrr: 'மாதாந்திர வருவாய் (MRR)',
      health: 'நிலை (G / A / R)',
      healthHint: 'பச்சை / மஞ்சள் / சிவப்பு',
      topBySessions: 'அமர்வுகள் வாரியாக சிறந்த கிளினிக்குகள்',
      topByRevenue: 'வருவாய் வாரியாக சிறந்த கிளினிக்குகள் (₹)',
    },
    clinics: {
      title: 'கிளினிக்குகள்',
      count: '{{count}} கிளினிக்குகள்',
      add: 'புதிய கிளினிக்',
      empty: 'இன்னும் கிளினிக்குகள் இல்லை.',
      searchPlaceholder: 'பெயர், திட்டம் அல்லது நிலை வாரியாக தேடு…',
      colName: CLIENT,
      colStatus: STATUS,
      colPlan: PLAN,
      colMrr: MRR,
      colTherapists: THERAPIST,
      colActiveClients: 'செயலில் உள்ள வாடிக்கையாளர்கள்',
    },
    subscriptions: {
      title: 'சந்தாக்கள்',
      count: '{{count}} கிளினிக்குகள்',
      empty: 'சந்தாக்கள் இல்லை.',
      col: {
        clinic: 'கிளினிக்',
        plan: PLAN,
        status: 'நிலை',
        mrr: MRR,
        renews: 'புதுப்பிப்பு / சோதனை முடிவு',
        actions: '',
      },
      markPaid: 'பணம் செலுத்தியதாகக் குறி',
      status: {
        active: 'செயலில்',
        trialing: 'சோதனை',
        past_due: 'நிலுவை',
        suspended: 'இடைநிறுத்தப்பட்டது',
        cancelled: 'ரத்து',
        none: 'திட்டம் இல்லை',
      },
    },
    usage: {
      title: 'பயன்பாடு & ஆரோக்கியம்',
      healthSummary: '{{green}} பச்சை · {{amber}} மஞ்சள் · {{red}} சிவப்பு',
      empty: 'பயன்பாட்டுத் தரவு இல்லை.',
      col: {
        clinic: 'கிளினிக்',
        health: 'ஆரோக்கியம்',
        sessions: 'அமர்வுகள் (30நா)',
        whatsapp: 'வாட்ஸ்அப்',
        sms: 'எஸ்எம்எஸ்',
        pdfs: 'PDFs',
        storage: 'சேமிப்பு',
        users: 'செயல் பயனர்கள்',
      },
      health: {
        green: 'ஆரோக்கியம்',
        amber: 'அபாயம்',
        red: 'நெருக்கடி',
        unknown: 'தெரியவில்லை',
      },
    },
    staff: {
      title: 'பணியாளர் பயனர்கள்',
      count: '{{count}} பணியாளர் கணக்குகள்',
      add: 'பணியாளரைச் சேர்',
      empty: 'பணியாளர் கணக்குகள் இல்லை.',
      active: 'செயலில்',
      inactive: 'முடக்கப்பட்டது',
      enable: 'இயக்கு',
      disable: 'முடக்கு',
      col: {
        member: 'உறுப்பினர்',
        role: 'பங்கு',
        status: 'நிலை',
        lastLogin: 'கடைசி உள்நுழைவு',
        actions: '',
      },
      role: {
        PLATFORM_OWNER: 'பிளாட்ஃபார்ம் உரிமையாளர்',
        CUSTOMER_SUCCESS: 'வாடிக்கையாளர் வெற்றி',
        SUPPORT: 'ஆதரவு',
        READONLY_AUDITOR: 'படிக்க-மட்டும் தணிக்கையாளர்',
      },
      form: {
        fullName: FULL_NAME,
        email: 'மின்னஞ்சல்',
        role: 'பங்கு',
        submit: 'கணக்கை உருவாக்கு',
        error: 'கணக்கை உருவாக்க முடியவில்லை (மின்னஞ்சல் பயன்பாட்டில் இருக்கலாம்).',
      },
      created: {
        title: 'கணக்கு உருவாக்கப்பட்டது',
        intro: '{{email}} உடன் இந்த சான்றுகளைப் பாதுகாப்பாகப் பகிரவும்.',
        copy: 'நகலெடு',
        warning: 'ஒருமுறை மட்டும் காட்டப்படும் — முதல் உள்நுழைவில் கடவுச்சொல்லை மாற்றவும்.',
        done: 'முடிந்தது',
      },
    },
    clinicStatus: {
      active: 'செயலில்',
      trial: TRIAL,
      trialing: TRIAL,
      suspended: 'இடைநிறுத்தப்பட்டது',
      cancelled: 'ரத்துசெய்யப்பட்டது',
      past_due: 'நிலுவை',
    },
    detail: {
      back: 'கிளினிக்குகளுக்குத் திரும்பு',
      notFound: 'கிளினிக் காணப்படவில்லை.',
      overview: 'கண்ணோட்டம்',
      legalName: 'சட்டப்பூர்வ பெயர்',
      contactEmail: 'தொடர்பு மின்னஞ்சல்',
      contactPhone: 'தொடர்பு தொலைபேசி',
      timezone: 'நேர மண்டலம்',
      createdAt: 'சேர்க்கப்பட்டது',
      subscription: SUBSCRIPTION,
      noSubscription: 'செயலில் சந்தா இல்லை.',
      plan: PLAN,
      subStatus: STATUS,
      mrr: MRR,
      periodEnd: 'புதுப்பிக்கப்படும்',
      therapists: THERAPIST,
      activeClients: 'செயலில் உள்ள வாடிக்கையாளர்கள்',
      sessions: SESSIONS,
      invoiced: 'விலைப்பட்டியல்',
      recentAudit: 'சமீபத்திய செயல்பாடு',
      noAudit: 'சமீபத்திய செயல்பாடு இல்லை.',
    },
    audit: {
      title: 'தணிக்கைப் பதிவு',
      subtitle: 'அனைத்து கிளினிக்குகளிலும் செயல்பாடு',
      empty: 'இந்த வடிகட்டிகளுக்கு பதிவுகள் இல்லை.',
      allClinics: 'அனைத்து கிளினிக்குகள்',
      filterClinic: 'கிளினிக் வாரியாக வடிகட்டு',
      filterAction: 'செயல் வாரியாக வடிகட்டு…',
      filterFrom: 'தொடக்க தேதி',
      filterTo: 'இறுதி தேதி',
      colTime: 'நேரம்',
      colClinic: CLIENT,
      colActor: 'செயல்படுத்தியவர்',
      colAction: ACTION,
      colEntity: 'பொருள்',
    },
    settings: {
      title: 'தள அமைப்புகள்',
      subtitle: 'அம்ச கொடிகள் மற்றும் தள கட்டமைப்பு',
      flags: 'அம்ச கொடிகள்',
      empty: 'இன்னும் அம்ச கொடிகள் இல்லை. கீழே ஒன்றைச் சேர்க்கவும்.',
      enabled: 'இயக்கப்பட்டது',
      disabled: 'முடக்கப்பட்டது',
      enable: 'இயக்கு',
      disable: 'முடக்கு',
      addKey: 'ஒரு அம்ச கொடியைச் சேர்க்கவும்',
      addPlaceholder: 'எ.கா. parent_app_v2',
      add: 'சேர்',
      col: {
        key: 'கொடி',
        state: 'நிலை',
        updated: 'புதுப்பிக்கப்பட்டது',
      },
    },
    wizard: {
      title: 'கிளினிக்கை சேர்',
      subtitle: 'கிளினிக், அதன் முதல் நிர்வாகி மற்றும் சந்தாவை உருவாக்கு',
      stepOf: 'படி {{step}} / {{total}}',
      clinicName: 'கிளினிக் பெயர்',
      legalName: 'சட்டப்பூர்வ பெயர்',
      contactEmail: 'தொடர்பு மின்னஞ்சல்',
      contactPhone: 'தொடர்பு தொலைபேசி',
      line1: 'முகவரி வரி 1',
      city: 'நகரம்',
      state: 'மாநிலம்',
      postalCode: 'அஞ்சல் குறியீடு',
      country: 'நாடு (ISO 3166-1 alpha-2)',
      adminName: 'முதல் நிர்வாகி பெயர்',
      adminEmail: 'முதல் நிர்வாகி மின்னஞ்சல்',
      planSlug: PLAN,
      trialDays: 'சோதனை நாட்கள் (விருப்பம்)',
      back: 'பின்',
      next: 'அடுத்து',
      submit: 'கிளினிக்கை சேர்',
    },
  },
} as const;
